// You can write more code here

/* START OF COMPILED CODE */

import Phaser from 'phaser';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TransitionWorldJungleToCave extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // boulderLeft
    const boulderLeft = scene.add.image(-1545, 0, 'game-all', 'wipe-boulders.png');
    boulderLeft.scaleX = 1.33;
    boulderLeft.scaleY = 1.33;
    this.add(boulderLeft);

    // boulderRight
    const boulderRight = scene.add.image(1545, 0, 'game-all', 'wipe-boulders.png');
    boulderRight.scaleX = 1.33;
    boulderRight.scaleY = 1.33;
    boulderRight.flipX = true;
    this.add(boulderRight);

    this.boulderLeft = boulderLeft;
    this.boulderRight = boulderRight;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private boulderLeft: Phaser.GameObjects.Image;
  private boulderRight: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  private coveredCallback: (() => void) | undefined;
  private doneCallback: (() => void) | undefined;

  public activate(coveredCallback?: () => void, doneCallback?: () => void) {
    if (coveredCallback) this.coveredCallback = coveredCallback;
    if (doneCallback) this.doneCallback = doneCallback;

    this.transitionIn();
    this.scene.time.delayedCall(500, this.transitionOut, [], this);
    if (this.doneCallback) this.scene.time.delayedCall(500, this.doneCallback);
  }

  public show() {
    this.transitionInInit();
    this.transitionIn();
  }

  public hide() {
    this.transitionOut();
  }

  public reset() {
    this.transitionInInit();
  }

  // protected init() {
  //   this.leavesLeft.x = -1589;
  //   this.leavesRight.x = 1589;
  // }

  transitionInInit() {
    this.boulderLeft.x = -1545;
    this.boulderRight.x = 1545;
    // this.leavesLeft.angle = -90;
    // this.leavesRight.angle = 90;
  }

  transitionIn() {
    this.scene.add.tween({
      targets: this.boulderLeft,
      x: -374,
      // angle: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: this.boulderRight,
      x: 374,
      // angle: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  transitionOut() {
    this.coveredCallback?.();

    this.scene.add.tween({
      targets: this.boulderLeft,
      x: -1545,
      // angle: -90,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In
    });

    this.scene.add.tween({
      targets: this.boulderRight,
      x: 1545,
      // angle: 90,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
